angular.module('FlexyBeautyApp.services')
    .factory('CompanyTypes', ['gettextCatalog',function () {

        let companyTypes = {

            MIGRATION      :{value: "migration"},
            NEW_ACCOUNT    :{value: "newAccount"},
            CUSTOMER       :{value: "customer"},
            BILLINGISSUE   :{value: "billingIssue"},
            BILLINGBLOCKED :{value:"billingBlocked"},
            BLOCKED        :{value: "blocked"},
            CANCELED       :{value: "canceled"},
            MODEL          :{value: "model"},
            PARTNER        :{value: "partner"},
            INTERNALTEST   :{value: "internalTest"}

        };
        return companyTypes;
    }])



// WEBPACK FOOTER //
// ./js/services/views/CompanyTypes.js